import { get } from 'lodash';

export default function getCaseSentByName(serviceCase = {}) {
  const sendByFirstName = get(serviceCase, 'primary_worker.first_name');
  const sendByLastName = get(serviceCase, 'primary_worker.last_name');

  if (sendByFirstName && sendByLastName) {
    return `${sendByFirstName} ${sendByLastName}`;
  }
  return get(serviceCase, 'referred_by_group.name', '');
}
